export default "__VITE_ASSET__BrMSAdFR__"